import React from 'react'

import { excludedServices } from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/constants'
import { GetCustomerCopyFunc } from '@lyrahealth-inc/shared-app-logic/src/models/customer/Customer'

import { CoverageNotice } from '../atoms/coverageNotice/CoverageNotice'

const servicesNotCovered = `There are some services that are not covered by Lyra, which include ${excludedServices}. For coverage and plan information on these types of services, contact Collective Health.`

export const redbull: GetCustomerCopyFunc = () => {
  return {
    servicesNotCovered,
    legalNotice: <CoverageNotice />,
  }
}
